import * as React from 'react';
import Typography from "@mui/material/Typography";

import Box from '@mui/material/Box';

import IconButton from '@mui/material/IconButton';

import * as Bs4Utils from '../../Bs4Components/Bs4Utils';
import { getBoxSx, getBoxStyle } from '../../Bs4Theme/Bs4UxTemplates';
import { SmallScreenContext, useStateUxTemplate } from '../../Bs4Theme/Bs4UxTemplates';

import {  
  startOfWeek, endOfWeek,  
  startOfMonth, endOfMonth,
  compareAsc,
  eachDayOfInterval, eachWeekOfInterval,
  format,
  getMonth,  
  differenceInMilliseconds, 
  addMilliseconds, addMinutes,
  setHours, getHours,
  setMinutes, getMinutes,
  startOfDay,
} from "date-fns";

import {   
  // TYPE_NAVIGATION,
  // TYPE_CALENDAR,
  // TYPE_AGENDE,
  // TYPE_SCHEDULER,
  // TYPE_MODIFIER,

  VIEW_TYPE_YEAR,
  VIEW_TYPE_MONTH,
  VIEW_TYPE_WEEK,
  VIEW_TYPE_DAY,

  // VIEW_TYPE_MODIFIER_LAYER0,
  // VIEW_TYPE_MODIFIER_LAYER1,
  // VIEW_TYPE_MODIFIER_ADJUSTMENT_TO_UNIT_WIDTH,

  // footerButtons,
  // isSelected,
  borderWidth,
  borderColor,
} from './Bs4ReportCalendarConst';

import Bs4ReportCalendarView from './Bs4ReportCalendarView'
import { ViewPeriodBackground, ViewPeriodForeground} from './Bs4ReportCalendarViewPeriod'

export default class Bs4ReportCalendarViewMonth extends Bs4ReportCalendarView {

  aaa = this.borderNow;
  borderStart = {
    borderLeft: `solid ${borderColor}`, 
    borderTop: `solid ${borderColor}`,     
    borderWidth: borderWidth,
  }

  borderLeft = {
    borderLeft: `solid ${borderColor}`, 
    borderWidth: borderWidth,
  }

  borderEnd = {
    borderRight: `solid ${borderColor}`, 
    borderBottom: `solid ${borderColor}`,
    borderWidth: borderWidth,
  }


  ViewDayName = (props) => {
    const report = this;

    return (
      <Box flex={1} display='flex' justifyContent='flex-end' alignItems='center'>
        <Typography sx={{userSelect: 'none'}}>{format(props.day.date, 'iii')}</Typography>
      </Box> 
    )
  }

  ViewDay = (props) => {
    const report = this;    

    const square = 25;

    
    const handleNavigateToDayDown = (event) => {    
      event.preventDefault();
      event.stopPropagation();
    }

    const handleNavigateToDay = (event) => {    
      props.onChangeView(props.day.date, VIEW_TYPE_DAY);
    }

    const handleNavigateToWeekDown = (event) => {    
      event.preventDefault();
      event.stopPropagation();
    }
    const handleNavigateToWeek = (event) => {    
      props.onChangeView(props.day.date, VIEW_TYPE_WEEK);
    }        

    const now = React.useMemo(() => {
      const now = startOfDay(new Date());
      const day = startOfDay(props.day.date);
      return compareAsc(now, day) === 0;
    }, [props.day.date])
    // console.log('...ViewDay...', props)
    
    return (
      <Box         
        flex={1} 
        display='flex' 
        flexDirection='column' 
        sx={{...report.borderEnd, pointerEvents: 'none'}}
      >
        <Box display='flex' flexDirection='row' justifyContent={'space-between'} alignItems='center'>
          {props.first ? 
            <IconButton
              onClick={handleNavigateToWeek}
              onPointerDown={handleNavigateToWeekDown}              
              size='small'
              sx={{
                width: square,
                height: square,
                padding: report.deyPadding,
                pointerEvents: 'auto',
                zIndex: 100,                
              }}
            >
              <Typography variant='subtitle2' sx={{opacity: 0.5, fontSize: '11px'}}>{format(props.day.date, 'w')}</Typography>
            </IconButton>
          : 
            <Box/>
          }
          
          <IconButton
            onClick={handleNavigateToDay}
            onPointerDown={handleNavigateToDayDown}
            size='small'
            sx={{            
              width: square,
              height: square,     
              pointerEvents: 'auto',       
              zIndex: 100,
              border: now ? '3px dashed #ff000022' : null,
            }}
          >
            <Typography variant='subtitle2' sx={{color: props.day.inMonth ? '#000000ff' : '#00000055'}}>{format(props.day.date, 'd')}</Typography>
          </IconButton>          
        </Box>        
      </Box>
    )
  }

  ViewWeek = (props) => {
    const report = this;
    const minHeight = 60;
    
    // console.log('...Bs4ReportCalendarMonth...ViewWeek...', props, lineArray, viewBackgroundArray);

    return (
      <Box
        // ref={setNodeRef}
        id='Box_Bs4ReportCalendarMonth_week'
        flex={1}
        display='flex'
        flexDirection='row'
        minHeight={minHeight}
        position='relative'
        overflow='visible'
      >
        <ViewPeriodBackground
          sx={{position: 'absolute', left: 0, top: 0, right: 0, bottom: 0}}
          startPeriod={props.week.start}
          endPeriod={props.week.end}
          bs4EventArray={props.week.bs4Events}
          startLine={1}
          maxLine={0}
          bs4kartotekaid={props.bs4KartotekaId} 
          onRowClick={props.onRowClick}
          onChangeView={props.onChangeView}
          bs4Calendar={props.bs4Calendar}
        />
        <Box
          id='Box_Bs4ReportCalendarMonth_week'
          position='absolute'
          left={0}
          top={0}
          right={0}
          bottom={0}
          display='flex'
          flexDirection='row'
          minHeight={minHeight}    
          sx={{pointerEvents: 'none'}}
        >
          {props.week.days.map((day, index) => {
            return (
              <report.ViewDay
                key={day.date}
                day={day}
                first={index === 0}
                onChangeView={props.onChangeView} 
                onNavigateTo={props.onNavigateTo}
              />
            )
          })}
        </Box>
        <ViewPeriodForeground
          sx={{flex: 1}}
          startPeriod={props.week.start}
          endPeriod={props.week.end}
          bs4EventArray={props.week.bs4Events}
          startLine={1}
          maxLine={0}
          bs4kartotekaid={props.bs4KartotekaId} 
          onRowClick={props.onRowClick}
          onChangeView={props.onChangeView}
          active={props.active}
          setActive={props.setActive}
          activeChangeTime={props.activeChangeTime}
          setActiveChangeTime={props.setActiveChangeTime}
          bs4EventAdd={props.bs4EventAdd}
          bs4Calendar={props.bs4Calendar}
        />
      </Box>
    )
  }

  handleTouchStartTimeout = null;
  
  setActiveNew = (pageX, pageY, month, refBox, props) => {
    const rect = refBox.current.getBoundingClientRect();
    if (!rect) return;

    const weekNumber = Math.floor(month.length * ((pageY - rect.top) / rect.height));
    const week = month[weekNumber];
    if (!week) return;

    let start = addMilliseconds(week.start, differenceInMilliseconds(week.end, week.start) / rect?.width * (pageX - rect?.left));
    start = props.bs4Calendar.roundTo(start);      
    const end = addMinutes(start, props.bs4Calendar.nearestTo);
    const newBs4Event = {
      Name: 'New bs4Event',
      start, 
      end,
      duration: differenceInMilliseconds(end, start),
      chtime: true,
      new: true,
      move: {
        cursor: 'e',
        active: true,
      },
    }         
    props.setActive({props: {el: {bs4Event: newBs4Event}}});
    if (navigator.vibrate) navigator.vibrate(30);
  };

  moveActivwNew = (pageX, pageY, month, refBox, props) => {
    const rect = refBox.current.getBoundingClientRect();
    if (!rect) return;

    const weekNumber = Math.floor(month.length * ((pageY - rect.top) / rect.height));
    const week = month[weekNumber];
    if (!week) return;

    let end = addMilliseconds(week.start, differenceInMilliseconds(week.end, week.start) / rect?.width * (pageX - rect?.left));
    end = props.bs4Calendar.roundTo(end);

    if (compareAsc(props.active.props.el.bs4Event.start, end) > 0) return;
    if (compareAsc(props.active.props.el.bs4Event.end, end) === 0) return;

    props.active.props.el.bs4Event.end = end;
    props.setActiveChangeTime(new Date());      
    if (navigator.vibrate) navigator.vibrate(1);
  }

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;
    const refBox = React.useRef(null);
    const month = React.useMemo(() => {
      const weeks = {};    
      props.bs4Calendar.getVisibleEvents().forEach(bs4Event => {        
        if (compareAsc(bs4Event.end, props.bs4Calendar.start) < 0) return;
        if (compareAsc(bs4Event.start, props.bs4Calendar.end) > 0) return;
          
        eachWeekOfInterval({start: bs4Event.start, end: bs4Event.end}).forEach(date => {
          const key = format(date, 'Y-I')
          let bs4Events = weeks[key];
          if (!bs4Events) {
            bs4Events = []
            weeks[key] = bs4Events;
          }
          bs4Events.push(bs4Event);
        })        
      });

      const month = eachWeekOfInterval({start: props.bs4Calendar.start, end: props.bs4Calendar.end}).map(weekDate => {
        const weekStart = startOfWeek(weekDate);
        const weekEnd = endOfWeek(weekDate);
        return {
          start: weekStart,
          end: weekEnd,
          bs4Events: weeks[format(weekStart, 'Y-I')] || [],
          days: eachDayOfInterval({start: weekStart, end: weekEnd}).map(dayDate => {            
            return {
              date: dayDate,
              bs4Events: [],
              inMonth: getMonth(props.bs4Calendar.date) === getMonth(dayDate),
            }
          }),
        }
      })
      
      return month;
    }, [props.bs4Calendar.date, props.calendarChangeTime])

    const handlePointerDown = React.useCallback((event) => {
      if (event.pointerType === 'touch') return;
      if (!props.bs4Calendar?.allowaddevent) return;
      this.setActiveNew(event.pageX, event.pageY, month, refBox, props);
    }, [props.bs4Calendar?.allowaddevent, month, refBox, props]);

    const handlePointerMove = React.useCallback((event) => {      
      // console.log('...PointerMove...', props.active?.props?.el?.bs4Event?.new);
      if (event.pointerType === 'touch') return;
      if (!props.active?.props?.el?.bs4Event?.new) return;
      this.moveActivwNew(event.pageX, event.pageY, month, refBox, props);
    }, [props.active?.props?.el?.bs4Event?.new, month, refBox, props]);

    const handlePointerUp = React.useCallback((event) => {
      if (event.pointerType === 'touch') return;   
      if (!props.active?.props?.el?.bs4Event?.new) return;
      props.bs4EventAdd(props.active?.props?.el?.bs4Event);
      props.setActive(null);
    }, [props.active?.props?.el?.bs4Event?.new, props.active?.props?.el?.bs4Event, props.bs4EventAdd, props.setActive]);

    const handleTouchStart = React.useCallback((event) => {
      // console.log('...TouchStart...', event);
      clearTimeout(this.handleTouchStartTimeout);
      if (!props.bs4Calendar?.allowaddevent) return;
      this.handleTouchStartTimeout = setTimeout(() => {
        // console.log('...TouchStart...Active');
        const touch = event.touches[0];
        this.setActiveNew(touch.pageX, touch.pageY, month, refBox, props);
      }, 200);      
    }, [props.bs4Calendar?.allowaddevent, month, refBox, props]);

    const handleTouchMove = React.useCallback((event) => {
      // console.log('...TouchMove...');
      clearTimeout(this.handleTouchStartTimeout);
      if (!props.active?.props?.el?.bs4Event?.new) return;
      const touch = event.touches[0];
      this.moveActivwNew(touch.pageX, touch.pageY, month, refBox, props);
    }, [props.active?.props?.el?.bs4Event?.new, month, refBox, props]);
    
    const handleTouchEnd  = React.useCallback((event) => {
      // console.log('...TouchEnd...', event);
      clearTimeout(this.handleTouchStartTimeout);
      if (!props.active?.props?.el?.bs4Event?.new) return;
      props.bs4EventAdd(props.active?.props?.el?.bs4Event);
      props.setActive(null);
    }, [props.active?.props?.el?.bs4Event?.new, props.active?.props?.el?.bs4Event, props.bs4EventAdd, props.setActive]);

    const handleKeyDown  = React.useCallback((event) => {
      // console.log('...KeyDown...', event);
      clearTimeout(this.handleTouchStartTimeout);
      if (event.code !== 'Escape') return;
      if (!props.active?.props?.el?.bs4Event?.new) return;      
      props.setActive(null);
    }, [props.active?.props?.el?.bs4Event?.new, props.active?.props?.el?.bs4Event, props.bs4EventAdd, props.setActive]);
    
    React.useEffect(() => {       
      window.addEventListener('pointermove', handlePointerMove);
      window.addEventListener('pointerup', handlePointerUp);

      window.addEventListener('touchmove', handleTouchMove);
      window.addEventListener('touchend', handleTouchEnd);

      window.addEventListener('keydown', handleKeyDown);

      return () => {
        window.removeEventListener('pointermove', handlePointerMove);
        window.removeEventListener('pointerup', handlePointerUp);

        window.removeEventListener('touchmove', handleTouchMove);
        window.removeEventListener('touchend', handleTouchEnd);

        window.removeEventListener('keydown', handleKeyDown);
      }
    }, [handlePointerMove, handlePointerUp, handleTouchMove, handleTouchEnd]);

    return (
      <Box 
        id='Box_Bs4ReportCalendarMonth_main'
        height='100%'
        display='flex'
        flexDirection='column'
        overflow='auto'
      >
        <Typography sx={{margin: '0 auto'}}>{format(props.bs4Calendar.date, 'LLLL yyyy')}</Typography>
        <Box
          id='Box_Bs4ReportCalendarMonth_header'
          display='flex'
          flexDirection='row'
        >
          {month[0].days.map(day => {
            return (
              <report.ViewDayName key={day.date} day={day}/>
            )
          })}
        </Box>
        <Box
          id='Box_Bs4ReportCalendarMonth_content'
          ref={refBox}
          flex={1}
          display='flex'
          flexDirection='column'
          sx={{
            ...report.borderStart,
            // touchAction: 'none',
          }}

          onPointerDown={handlePointerDown}
          // onPointerMove={handlePointerMove}
          // onPointerUp={handlePointerUp}
          
          onTouchStart={handleTouchStart}
          // onTouchMove={handleTouchMove}
          // onTouchEnd={handleTouchEnd}
        >
          {month.map(week => {
            return (
              <report.ViewWeek 
                key={week.start} 
                month={month}
                week={week} 
                onChangeView={props.onChangeView} 
                onRowClick={props.onRowClick}
                bs4kartotekaid={props.bs4KartotekaId} 
                onNavigateTo={props.onNavigateTo}
                day={props.day}                
                active={props.active}
                setActive={props.setActive}
                activeChangeTime={props.activeChangeTime}
                bs4EventAdd={props.bs4EventAdd}
                bs4Calendar={props.bs4Calendar}
              />
            )
          })}
        </Box>
      </Box>
    );    
  });
}